define('gameday-index-gdcalendar/GDIndexCalendarComponent',['require','exports','module','jquery','gameday-index-component-base/GDIndexComponentBase','message-service/message-service','gameday-index-enums/enums/events/LoadEvents','app-console/app-console','responsive-gameday-calendar/responsive-gameday-calendar'],function(require, exports, module) {
	// require imports
	var $ = require("jquery"),
		BaseClass = require("gameday-index-component-base/GDIndexComponentBase"),
		dispatcher = require("message-service/message-service"),
		LoadEvts = require("gameday-index-enums/enums/events/LoadEvents"),
		logg = require("app-console/app-console"),
		Calendar = require('responsive-gameday-calendar/responsive-gameday-calendar');

	// instance variables
	var Superclass,
			appConfig = { };

	function GDCalendar(compID, divID) {
		Superclass.init(compID, divID);

		this.init();
	}


	BaseClass.spawn(GDCalendar).define({
		init: function() {
			logg.log(this.targetDiv);

			var calInstance = new Calendar(this.targetDiv);

			dispatcher.on(LoadEvts.pageReady, function(){
				calInstance.load(appConfig);
			});

			this.buildAppSettings();
			this.initialized = true;

			dispatcher.publish(LoadEvts.componentReady, this.componentID);
		},

		buildAppSettings: function() {
			// expand / extend the appConfig obj from above
			// iterate through config objects to construct the prpper params
		}
	});

	Superclass = GDCalendar.superclass;
	return GDCalendar;
});
